// Traffic density switch.
import { cars } from '../vehicles/cars.js';
import { TRAFFIC } from '../vehicles/traffic.js';
import { tr } from './lang.js';
import { bTraffic } from '../dom.js';

export let trafficLevel;

export function buildTrafficToggle() {
  cars.forEach((c, i) => (c.idx = i));
  // density switch: pooled vehicles beyond the chosen count are hidden and skipped (scooters, pool undefined, always ride)
  trafficLevel = 'mid';
  try {
    trafficLevel = localStorage.getItem('traffic') || 'mid';
  } catch (e) {}
  function setTraffic(level) {
    trafficLevel = TRAFFIC[level] ? level : 'mid';
    const n = TRAFFIC[trafficLevel];
    for (const c of cars)
      if (c.pool !== undefined) {
        c.off = c.pool >= n;
        c.g.visible = !c.off;
      }
    try {
      localStorage.setItem('traffic', trafficLevel);
    } catch (e) {}
    if (window.bTraffic)
      bTraffic.textContent = tr('traffic') + ': ' + tr('traffic_' + trafficLevel);
  }
  window.trafficReady = true;
  setTraffic(trafficLevel);
  bTraffic.onclick = () => {
    setTraffic({ low: 'mid', mid: 'high', high: 'low' }[trafficLevel]);
    bTraffic.blur();
  };
}
